var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassdoorCompanyJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aaced7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25529,
    stopColor: "#59bb8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#0daa41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d775f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.69073,73.18146v-6.01489h-5.24573v.0802h-10.00824v1.03558c0,3.37921,2.73932,6.11853,6.11847,6.11853h9.29425c-.09491-.39307-.15875-.79767-.15875-1.21942Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.30505,32.83344h7.25818v-1.11572c0-3.37921-2.73932-6.11859-6.11847-6.11859h-22.88953c-3.37915,0-6.11847,2.73938-6.11847,6.11859v30.22058h7.25818v-29.10486h20.61011Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.30505,46.04779c.19391-.01825.38464-.04779.58325-.04779h6.67493v-7.85809h-7.25818v7.90588Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.9657,54.35687v-2.12988c0-1.22827-.99878-2.22699-2.22705-2.22699h-6.85034c-1.22797,0-2.22699.99872-2.22699,2.22699v2.12988h-5.75116c-.67352,0-1.21942.54596-1.21942,1.21942v2.96899c0,1.65125,1.33862,2.98987,2.98987,2.98987h19.26575c1.65125,0,2.98987-1.33862,2.98987-2.98987v-2.96899c0-.67346-.5459-1.21942-1.21942-1.21942h-5.7511ZM68.06,54.35687h-.49677v-.00006h-6.99628v-2.12982c0-.17743.14392-.32129.32135-.32129h6.85034c.17743,0,.32135.14386.32135.32129v2.12988Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.43549,74.30505c.14587.06171.30634.09583.47467.09583h22.80664c.67352,0,1.21942-.54596,1.21942-1.21942v-9.99023c-.86316.55737-1.88818.88489-2.98987.88489h-19.26575c-1.10168,0-2.12671-.32751-2.98987-.88489v9.99023c0,.50507.30707.93848.74475,1.1236Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassdoorCompanyJobs);
export default __webpack_public_path__ + "static/media/glassdoor-company-jobs.31117f5f45ad51b2a52748c52a51f38c.svg";
export { ForwardRef as ReactComponent };